"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.department = void 0;
var utils_1 = require("../../utils");
var departmentsUrl = '/departments';
var departmentNoUrl = '/{departmentNo}';
// [Department]
exports.department = function (axios) {
    return {
        putDepartmentsDisplayOrder: function (putDepartmentsDisplayOrderRequest) {
            var url = "" + departmentsUrl + departmentNoUrl + "/display-order";
            url = utils_1.paramPathchange(url, putDepartmentsDisplayOrderRequest);
            return axios.put(url, putDepartmentsDisplayOrderRequest.data);
        },
        deleteDepartments: function (deleteDepartmentsRequest) {
            var url = "" + departmentsUrl + departmentNoUrl;
            url = utils_1.paramPathchange(url, deleteDepartmentsRequest);
            return axios.delete(url);
        },
        putDepartments: function (putDepartmentsRequest) {
            var url = "" + departmentsUrl + departmentNoUrl;
            url = utils_1.paramPathchange(url, putDepartmentsRequest);
            return axios.put(url, putDepartmentsRequest.data);
        },
        postDepartments: function (postDepartmentsRequest) {
            return axios.post("" + departmentsUrl, postDepartmentsRequest.data);
        },
        getDepartments: function () {
            return axios.get("" + departmentsUrl);
        }
    };
};
